import { Stack } from 'component-library';
import React, { PropsWithChildren } from 'react';

import { OnboardingPageHeading, OnboardingPagePaper } from '@/layout/OnboardingPage';

interface ActivateAccountPageContentProps extends PropsWithChildren {
  headlineText: string;
}

export const ActivateAccountPageContent: React.FC<ActivateAccountPageContentProps> = ({ headlineText, children }) => {
  return (
    <>
      <OnboardingPageHeading headlineText={headlineText} />
      <OnboardingPagePaper>
        <Stack className='items-center' spacing={3}>
          {children}
        </Stack>
      </OnboardingPagePaper>
    </>
  );
};
